import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { useDispatch, useSelector } from 'react-redux';
import {
  advanceToStep,
  setCanAdvance,
  setLayoutsVGVs,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useEffect, useState } from 'react';
import { ILayoutValuation } from '../../../../redux/studies.model';
import { postStudyStep } from '../../../../redux/studies.controller';
import { AddAlert } from '../../../../../../../component';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
} from '../../../../../redux/dashboardActions';

export const CalculateVGV: React.FC = () => {
  const { layoutsValuationPrimaryResponse, currentStep, id } =
    useSelector(studiesSelector);
  const dispatch = useDispatch();
  const [numbersOfUnits, setNumbersOfUnits] = useState<number[]>(
    layoutsValuationPrimaryResponse?.map((el) => 0) ?? [0]
  );
  const handleInput = (
    event: React.FormEvent<HTMLInputElement>,
    layoutIndex: number
  ) => {
    if (parseInt(event.currentTarget.value) >= 0) {
      setNumbersOfUnits(
        numbersOfUnits.map((el, elIndex) =>
          elIndex === layoutIndex ? parseInt(event.currentTarget.value) : el
        )
      );
    }
  };

  const handleClickCalculate = async () => {
    if (layoutsValuationPrimaryResponse) {
      const payload = {
        layouts: layoutsValuationPrimaryResponse.map((el, index) => ({
          id: el.id,
          quantity: numbersOfUnits[index],
        })),
      };

      try {
        const response = await postStudyStep(4, id, payload);
        dispatch([
          setLayoutsVGVs(response.vgv_primary_secondary),
          advanceToStep(currentStep.nextStep),
          AddAlert('success', 'VGV calculado'),
        ]);
      } catch (e) {
        return;
      }
    }
  };
  useEffect(() => {
    if (numbersOfUnits.every((el) => el > 0)) {
      dispatch(setCanAdvance(true));
    } else {
      dispatch(setCanAdvance(false));
    }
  }, [numbersOfUnits]);
  useEffect(() => {
    dispatch([setDisplayCharts(null), removeMarkers(), removeClusters()]);
  }, []);

  const isDisabled = (): boolean => {
    return numbersOfUnits.some((elem) => elem <= 0);
  };

  return (
    <div className="calculate-vgv">
      <p className="helper-text">{nls.studyCreationGuide.steps.step4.helper}</p>
      {layoutsValuationPrimaryResponse?.map(
        (layout: ILayoutValuation, index) => {
          return (
            <section
              className="calculate-vgv__building-layout-calculation"
              key={index}
            >
              <h6 className="layout-number">
                {nls.studyCreationGuide.steps.step4.layoutNumber} {layout.id}
              </h6>
              <div className="calculate-vgv__building-layout-calculation__row">
                <p>{nls.studyCreationGuide.steps.step4.area}</p>
                <p style={{ fontWeight: 700 }}>{layout.area}</p>
              </div>
              <div className="calculate-vgv__building-layout-calculation__row">
                <p>{nls.studyCreationGuide.steps.step4.numberOfUnits}</p>
                <input
                  type="number"
                  data-cy="CalcVGVNumberOfUnits"
                  placeholder="00"
                  value={numbersOfUnits[index]}
                  onChange={(event) => handleInput(event, index)}
                  className="default-input"
                />
              </div>
            </section>
          );
        }
      )}
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          <button
            className="btn normal primary"
            data-cy="StudyCreationGuideNextStep"
            type="submit"
            onClick={handleClickCalculate}
            disabled={isDisabled()}
          >
            {nls.studyCreationGuide.buttons.calculate}
          </button>
        </div>
      </div>
    </div>
  );
};
